import { Button } from "$components/button/button";
import { PlusIconBorderless } from "$components/icons";
import React from "react";
import { FormattedMessage } from "react-intl";

interface AddSuppliesButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const AddSuppliesButton = ({
  onClick: handleClick,
  disabled = false,
}: AddSuppliesButtonProps): React.ReactElement => {
  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleClick}
      disabled={disabled}
      data-testid="consultation.addSuppliesButton"
      startIcon={<PlusIconBorderless color="primary" />}
    >
      <FormattedMessage
        id="consultation.addSupplies"
        defaultMessage="Supplies"
      />
    </Button>
  );
};

export default AddSuppliesButton;
